export default __webpack_public_path__ + "static/media/background3.dc04e69f.jpg";